<template>
  <layout-content-horizontal-nav :nav-menu-items="navMenuItems">
    <!-- Default Slot -->
    <slot></slot>

    <!-- Navbar -->
    <template #navbar>
      <div class="navbar-content-container">
        <div class="d-flex align-center">
          <v-app-bar-nav-icon v-if="$vuetify.breakpoint.mdAndDown"></v-app-bar-nav-icon>
          <router-link to="/" class="d-flex align-center text-decoration-none">
            <v-img :src="appLogo" max-height="30px" max-width="30px" alt="logo" contain class="me-3"></v-img>
            <h2 class="app-title text--primary">
              {{ appName }}
            </h2>
          </router-link>
        </div>

        <!-- Right Content: I18n, Light/Dark, Notification & User Dropdown -->
        <div class="d-flex align-center">
          <app-bar-theme-switcher></app-bar-theme-switcher>
          <app-bar-user-menu class="ms-2"></app-bar-user-menu>
        </div>
      </div>
      <v-overlay
        :value="$store.state.shallContentShowOverlay"
        z-index="5"
        absolute
        class="system-bar-overlay"></v-overlay>
    </template>

    <!-- Slot: footer -->
    <template #footer>
      <div class="d-flex justify-space-between">
        <span
          >COPYRIGHT &copy;
          {{ new Date().getFullYear() }}
          ThemeSelection, All rights Reserved</span
        >
        <div class="d-flex align-center">
          <span>Hand-crafted &amp; Made with</span>
          <v-icon color="error" class="ms-2">
            {{ icons.mdiHeartOutline }}
          </v-icon>
        </div>
      </div>
    </template>
  </layout-content-horizontal-nav>
</template>

<script>
  import LayoutContentHorizontalNav from "@core/layouts/variants/content/horizontal-nav/LayoutContentHorizontalNav.vue";
  import { fetchNavigationLinks } from "@/navigation/vertical";

  // App Bar Components
  import AppBarThemeSwitcher from "@core/layouts/components/app-bar/AppBarThemeSwitcher.vue";
  import AppBarUserMenu from "@/components/AppBarUserMenu.vue";

  import themeConfig from "@themeConfig";
  import { mdiHeartOutline } from "@mdi/js";
  import { getVuetify } from "@core/utils";

  export default {
    components: {
      LayoutContentHorizontalNav,
      // App Bar Components
      AppBarThemeSwitcher,
      AppBarUserMenu,
    },
    setup() {
      const $vuetify = getVuetify();
      const navMenuItems = fetchNavigationLinks($vuetify.lang); // passes down translator into router

      return {
        navMenuItems,

        // App Config
        appName: themeConfig.app.name,
        appLogo: themeConfig.app.logo,

        // Icons
        icons: {
          mdiHeartOutline,
        },
      };
    },
  };
</script>

<style lang="scss" scoped>
  .app-title {
    font-size: 1.25rem;
    font-weight: 600;
  }

  .navbar-content-container {
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-grow: 1;
    position: relative;
  }
</style>
